import Component from '../abstracts/Component';

export default class TippyComponent extends Component {

  get SELECTORS() {
    return {
      main: '.js-tippy',
      layer: '.js-tippy-layer'
    };
  }

  get CLASSES() {
    return {
      show: 'show'
    };
  }

  constructor() {
    super();
  }

  importTooltip() {

    let layer = document.querySelector(this.SELECTORS.layer);

    this.$on('click', ({event}) => {
      if (!layer.classList.contains('in')) {
        this.$emit(this.$customEvents.BOOK_LAYER_EVENTS.open);
      } else {
        this.$emit(this.$customEvents.BOOK_LAYER_EVENTS.close);
      }
    }, this.SELECTORS.main);

    this.$on('click', ({event}) => {
      event.preventDefault();
      this.$emit(this.$customEvents.BOOK_LAYER_EVENTS.close);
    }, `${this.SELECTORS.layer} .js-close`);

    this.$on(this.$customEvents.BOOK_LAYER_EVENTS.open, ({event, payload}) => {
      layer.classList.add('in');
    });

    this.$on(this.$customEvents.BOOK_LAYER_EVENTS.close, ({event, payload}) => {
      layer.classList.remove('in');
    });
  }

  render() {
    if (document.querySelectorAll(this.SELECTORS.main)) this.importTooltip()
  }
}
